import type { CrudState, GetterClass } from '../../../models'

export class StateGetter implements GetterClass {
  static execute(this: void, state: CrudState): CrudState {
    return state
  }
}
